import { Button, ButtonGroup, Content, Dialog, Divider, Flex, Heading, Link } from '@adobe/react-spectrum';
import LinkOutLight from '@spectrum-icons/workflow/LinkOutLight';
import PropTypes from 'prop-types';
import React from 'react';

import parseHTML from '../../../utils/ParseHTML';

const LicenseAgreementDialog = (props) => {
  const { cloud, licenseAgreement, privacyPolicy, close, onAccept } = props;

  return (
    <Dialog>
      <Heading>End-User License Agreement</Heading>
      <Divider />
      {cloud === 'ec' ? (
        <Content>
          <p>
            Before acquiring this application, please review the privacy policy and the terms and conditions of the
            end-user license agreement.
          </p>
          <Flex direction="column">
            {privacyPolicy && (
              <Link>
                <a href={privacyPolicy} target="_blank" rel="noopener noreferrer">
                  Read privacy policy
                  <LinkOutLight
                    width="size-200"
                    position="relative"
                    marginStart="size-65"
                    top="size-100"
                    aria-label="Open in a new tab"
                  />
                </a>
              </Link>
            )}
            <Link marginTop="size-125">
              <a href={licenseAgreement} target="_blank" rel="noopener noreferrer">
                Read end-user license agreement
                <LinkOutLight
                  width="size-200"
                  position="relative"
                  marginStart="size-65"
                  top="size-100"
                  aria-label="Open in a new tab"
                />
              </a>
            </Link>
          </Flex>
        </Content>
      ) : (
        <Content>{parseHTML(licenseAgreement)}</Content>
      )}
      <ButtonGroup>
        <Button variant="secondary" onPress={close}>
          Cancel
        </Button>
        <Button variant="cta" onPress={onAccept}>
          Accept and Continue
        </Button>
      </ButtonGroup>
    </Dialog>
  );
};

export default LicenseAgreementDialog;

LicenseAgreementDialog.propTypes = {
  licenseAgreement: PropTypes.string,
  privacyPolicy: PropTypes.string,
  close: PropTypes.func,
  onAccept: PropTypes.func,
  cloud: PropTypes.string,
};
